import { jsx as _jsx } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
import useDataStore from '../Data/dataStore';
import MenuItemGraphics from './MenuItemGraphics';
import { API, homePath } from '../globalUtils';
import { getPath } from '../Router/Router';
const MenuList = ({ open, closeMenu }) => {
    const location = useLocation().pathname;
    const setup = useDataStore((state) => state.data[API.setup]);
    if (!setup) {
        return null;
    }
    const { menu } = setup;
    return (_jsx("div", { className: "menu-panel", children: (menu ?? []).map((item, idx) => {
            const { name, slug } = item;
            const active = getPath(location) === getPath(slug);
            const isHome = getPath(slug) === homePath;
            return (_jsx("div", { className: "menu-item", onClick: closeMenu, children: _jsx(Link, { to: `/${slug ?? ''}${isHome ? '' : '/'}`, "aria-label": name, children: _jsx(MenuItemGraphics, { name: name, index: idx, open: open, active: active }) }) }, name));
        }) }));
};
export default MenuList;
